import { SecurityService } from '../../../../../services/security.service';
import { UserSummary } from './../../../../../models/administration/user';
import { Component, OnInit, Input, Output, EventEmitter, OnChanges, SimpleChanges, ChangeDetectionStrategy } from '@angular/core';
import { ThemeManagerService } from '~/services/theme-manager';
import { LayoutComponent } from '~/shared/components/layout/layout.component';
import { IColumnGroup } from '~/models/modules/Common/editColumnsGroups';
import { GridLayoutManagerService } from '../grid-layout-manager';

@Component({
    selector: 'app-edit-columns',
    templateUrl: './edit-columns.component.html',
    styleUrls: ['./edit-columns.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class EditColumnsComponent implements OnInit, OnChanges {
  _data: any[];
  @Input()
  set data(_dataInput: any[]) {
    this._data = [..._dataInput];
  }
  get data(): any[] {
    return this._data;
  }
  @Input() selectedColumns: any[];

  @Output() save: EventEmitter<any> = new EventEmitter();
  @Output() close: EventEmitter<any> = new EventEmitter();

  _groupExpandData: IColumnGroup[] = [];
  _filteredInput: any[];
  _searchValue: string = '';

  _theme: string;
  _currentUser: UserSummary;
  _generalLicense: any;

  get maxColumns(): number {
    return this._generalLicense?.extendedInventoryColumns ? 15 : 12;
  }

  constructor(
    private _themeManager: ThemeManagerService,
    private _layoutComponent: LayoutComponent,
    private _securityService: SecurityService,
    private _gridLayoutManagerService: GridLayoutManagerService,
  ) {
    this._themeManager.themeChange.subscribe((data) => {
      this._theme = data;
      this._currentUser = this._securityService.currentUser;
    });

    this._securityService.getLicense().subscribe((x: any) => {
      if (x && x.general) {
        this._generalLicense = x.general;
      } else {
        this._generalLicense = x;
      }
    });
  }
  ngOnChanges(changes: SimpleChanges): void {
    if (changes.data.currentValue != changes.data.previousValue) {
      this._filteredInput = this.data;
      this._groupExpandData = [];
      this._buildColumnGroups();
    }
  }

  ngOnInit(): void {
    let res = this.data;
    this._groupExpandData = [];
    this._filteredInput = this.data;

    this._buildColumnGroups();
    /* setTimeout(() => {
      this.doSearch();
    }, 1000); */

  }
  _buildColumnGroups() {
    //if(this._groupExpandData.length == 0){
    this._filteredInput.forEach((col: any) => {
      if (this._currentUser && this._currentUser.isEnterprise) {
        col.items = col.items.filter((f: any) => f.field.toLowerCase() != 'notes')
        // let notesField = col.items.filter((f:any) => f.field.toLowerCase() == 'notes');
        // if(notesField != undefined && notesField.length > 0){
        //   return;
        // }
        if (col.items.length == 0)
          return;
      }
      let _itemCol = <IColumnGroup>({});
      _itemCol.groupValue = col.value ?? '';
      _itemCol.isExpanded = false;
      _itemCol.items = col.items;
      _itemCol.selectedCount = col.items.filter((f: any) => f.selected == true)?.length ?? 0
      this._groupExpandData.push(_itemCol);
    });
    this._groupExpandData[0].isExpanded = true;
    //}
    //else{
    //  this._groupExpandData.forEach((item:IColumnGroup) => {
    //    item.selectedCount = item.items.filter((f:any) => f.selected == true)?.length ?? 0
    // });
    //}
  }
  _isExpanded(groupValue: string) {
    let _retVal = false;
    let itemCol = this._groupExpandData.find(f => f.groupValue.toLocaleLowerCase() == groupValue.toLocaleLowerCase() && f.isExpanded == true);
    if (itemCol != undefined) {
      _retVal = true;
    }
    return _retVal;
  }
  _toggleExpand(groupValue: string) {
    let itemCol = this._groupExpandData.find(f => f.groupValue.toLocaleLowerCase() == groupValue.toLocaleLowerCase());
    if (itemCol != undefined) {
      itemCol.isExpanded = !itemCol.isExpanded;
    }
  }
  _selectedFields(groupValue: string) {
    let _retVal = 0;
    let itemCol = this._groupExpandData.find(f => f.groupValue.toLocaleLowerCase() == groupValue.toLocaleLowerCase());
    _retVal = itemCol.selectedCount ?? 0;
    /* if(itemCol != undefined){
      let cols = itemCol.items.filter(f => f.selected == true);
      _retVal = cols?.length ?? 0
    } */
    return _retVal;
  }
  _expandAll() {
    this._groupExpandData.forEach((f: IColumnGroup) => { f.isExpanded = true });
  }
  _collapseAll() {
    this._groupExpandData.forEach((f: IColumnGroup) => { f.isExpanded = false });
  }
  doSearch() {
    this._groupExpandData = [];
    this._filteredInput = this.data;
    if (this._searchValue != '') {
      this._filteredInput = this._filteredInput.filter(f => f.items.some((v: any) => v.title.toLowerCase().includes(this._searchValue.toLowerCase()) || v.gridFieldText?.currentText?.toLowerCase().includes(this._searchValue.toLowerCase())));
      this._filteredInput.forEach((col: any) => {
        let _itemCol = <IColumnGroup>({});
        _itemCol.groupValue = col.value ?? '';
        _itemCol.isExpanded = true;
        _itemCol.items = col.items.filter((f: any) => f.title.toLowerCase().includes(this._searchValue.toLowerCase()) || f.gridFieldText?.currentText?.toLowerCase().includes(this._searchValue.toLowerCase()));
        _itemCol.selectedCount = _itemCol.items.filter((f: any) => f.selected == true)?.length ?? 0
        this._groupExpandData.push(_itemCol);
      });
      this._groupExpandData[0].isExpanded = true;
    }
    else {
      this._buildColumnGroups();
    }
    // let allItems = this._filteredInput.map(item => {return item.items});

  }
  _onItemValueChange(event: any, column: any, groupValue: string) {
    let itemCol = this._groupExpandData.find(f => f.groupValue.toLocaleLowerCase() == groupValue.toLocaleLowerCase());
    if (event.target.checked) {
      if (this.selectedColumns.length >= this.maxColumns) {
        event.target.checked = false;
        this._layoutComponent.openPopup({
          title: 'Alert',
          message: 'The maximum allowed columns is ' + this.maxColumns + '.',
          returnAfterOkCloseClick: true,
          withoutConfirm: true
        });
      }
      else {
        this.selectedColumns.push(column);
        itemCol.selectedCount++;
      }
    }
    else {
      this.selectedColumns = this.selectedColumns.filter(x => x.id != column.id);
      itemCol.selectedCount--;
    }
    //itemCol.selectedCount = itemCol.items.filter((f: any) => f.selected == true)?.length ?? 0
    //this._buildColumnGroups()
  }

  _onSave() {
    this.save.emit(this.selectedColumns);
    // if(this.GridFieldsSubscription)
    // this.GridFieldsSubscription.unsubscribe();
    // this.GridFieldsSubscription = this._gridFields
    // .getGridFieldsByPage(this.page)
    // 
    // .subscribe((data: any) => {
    //this._gridLayoutManagerService.setGridColumnSubjects('stockItems', this.selectedColumns);
    // this._gridColumns = data;
    // this.initGrid();
    //});
  }

  _onClose() {
    this.close.emit();
  }

  _isItemSelected(id: any) {
    return this.selectedColumns.some(item => item.id === id);
  }
}
